import { render, staticRenderFns } from "./BracketCategories.vue?vue&type=template&id=360c88be&"
import script from "./BracketCategories.vue?vue&type=script&lang=js&"
export * from "./BracketCategories.vue?vue&type=script&lang=js&"
import style0 from "./BracketCategories.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports